module.exports = __webpack_public_path__ + "img/orthopedic-card-basic.3191d595.png";